<template lang="pug">
  div
    el-row
      component(:is="changeComponent", ref="tituloCertidao", :despacho="despacho", :tipo="despacho.processo.tipo.codigo" )
</template>
<script>

import AppFormularioTitulo from '@/screens/analise/components/AppFormularioTitulo'
import AppFormularioCertidao from '@/screens/analise/components/AppFormularioCertidao'

export default {

  components: {
    AppFormularioTitulo,
    AppFormularioCertidao
  },

  props: {
    despacho: {
      type: Object,
      required: true
    }
  },

  computed: {
    changeComponent () {
      switch (process.env.ESTADO) {
        case 'ma':
          return this.estadoMa
        default:
          return this.estadoPaAp
      }
    },
    estadoPaAp () {
      switch (this.despacho.processo.tipo.codigo) {
        case 'PEAEX':
        case 'ONEROSO':
        case 'NAO_ONEROSO':
        case 'TEQ':
        case 'REGULARIZACAO_URBANA':
          return 'AppFormularioTitulo'
        case 'CERTIDAO_TITULO':
          return 'AppFormularioCertidao'
        default:
          break
      }
    },
    estadoMa () {
      return 'AppFormularioTitulo'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/components/AppCadastraTituloCertidao.vue